import { useMemo } from 'react';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import Select, { SelectOption } from 'components/ui/Select';
import Card from 'components/ui/Card';
import { Notepad } from 'assets/icons/revamp';
import COLOR from 'constants/color';
import { EMPTY_STRING, TAKE_NOTE_OPTION } from 'constants/general';
import { t } from 'services/i18n.service';
import { updateMoreOptionTakeNotes } from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';

const options: SelectOption[] = [
  {
    label: 'tabs_revamp.log_data_tab.dont_take_notes',
    value: TAKE_NOTE_OPTION.NO_NOTE
  },
  {
    label: 'tabs_revamp.log_data_tab.take_notes_during_activity',
    value: TAKE_NOTE_OPTION.DURING_ACTIVITY
  },
  {
    label: 'tabs_revamp.log_data_tab.take_notes_at_end_of_activity',
    value: TAKE_NOTE_OPTION.END_OF_ACTIVITY
  }
];

const TakeNotes: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);

  const noteValue = useMemo(() => {
    if (activity?.take_notes === TAKE_NOTE_OPTION.NO_NOTE) {
      return TAKE_NOTE_OPTION.NO_NOTE;
    }
    if (activity?.take_notes === TAKE_NOTE_OPTION.DURING_ACTIVITY) {
      return TAKE_NOTE_OPTION.DURING_ACTIVITY;
    }
    if (activity?.take_notes === TAKE_NOTE_OPTION.END_OF_ACTIVITY) {
      return TAKE_NOTE_OPTION.END_OF_ACTIVITY;
    }
    return EMPTY_STRING;
  }, [activity?.take_notes]);

  const handleChange = (value: string) => {
    dispatch(updateMoreOptionTakeNotes(value));
  };

  return (
    <Card className='flex flex-col ~gap-3/4'>
      <div className='flex items-center ~gap-2/3'>
        <Notepad
          className='~w-4/5 ~h-4/5'
          fill={COLOR.PRIMARY.LIGHT_900}
          fillDarkMode={COLOR.PRIMARY.DARK_500}
        />
        <h3 className='~text-xs/base font-medium text-black dark:text-white'>
          {t('tabs_revamp.log_data_tab.take_notes')}
        </h3>
      </div>
      <Select
        options={options.map(({ label, value }) => ({
          label: t(label),
          value
        }))}
        value={noteValue}
        onChange={handleChange}
        size='sm'
        variant='filled'
        isFullWidth
        className='w-full'
        placeholder={t('tabs_revamp.log_data_tab.take_notes')}
      />
    </Card>
  );
};

export default TakeNotes;
